if (!customElements.get('bundle-product-form')) {
  class BundleProductForm extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.form = this.querySelector('form[data-type="add-to-cart-form"]');
      this.variantPicker = this.querySelector('bundle-variant-picker');
      this.submitButton = this.querySelector('[type="submit"]');
      this.cart = document.querySelector('cart-drawer');

      if (this.form) {
        this.form.addEventListener('submit', this.onSubmit.bind(this), true);
      }
    }

    getBundleItems(formQty) {
      const qty = parseInt(formQty, 10) || 1;
      let items;

      if (this.variantPicker && typeof this.variantPicker.getSelectedVariants === 'function') {
        items = this.variantPicker.getSelectedVariants();
      } else {
        const jsonScript = this.querySelector('[data-bundle-products]');
        if (!jsonScript) return [];
        try {
          const data = JSON.parse(jsonScript.textContent);
          items = (data.products || []).map(p => ({
            id: p.variants && p.variants[0] ? p.variants[0].id : null,
            quantity: p.quantity || 1,
            properties: {
              _bundle_id: data.bundleId,
              _bundle_handle: data.bundleHandle
            }
          })).filter(v => v.id !== null);
        } catch (e) {
          console.error('[BundleProductForm] Failed to parse bundle data', e);
          return [];
        }
      }

      if (qty > 1) {
        items = items.map(item => ({ ...item, quantity: item.quantity * qty }));
      }

      return items;
    }

    onSubmit(event) {
      event.preventDefault();
      event.stopImmediatePropagation();

      if (!this.submitButton) return;
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      if (this.getAttribute('data-bundle-unavailable') === 'true') return;
      if (this.submitButton.hasAttribute('disabled')) return;

      const formQty = (
        this.form.querySelector('[name="quantity"]') ||
        this.form.elements.quantity
      );
      const qty = formQty ? formQty.value : 1;

      const items = this.getBundleItems(qty);
      if (!items || items.length === 0) {
        console.warn('[BundleProductForm] No bundle items resolved.');
        return;
      }

      this.submitButton.setAttribute('aria-disabled', 'true');
      this.submitButton.classList.add('loading');
      const spinner = this.submitButton.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      if (this.cart) {
        this.cart.setActiveElement(document.activeElement);
      }

      const body = {
        items,
        sections_url: window.location.pathname
      };

      if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
        body.sections = this.cart.getSectionsToRender().map(s => s.id);
      }

      const firstVariantId = items[0] ? items[0].id : null;

      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(body)
      })
        .then(response => response.json())
        .then(response => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'bundle-product-form',
              productVariantId: firstVariantId,
              errors: response.description,
              message: response.message
            });
            this.handleErrorMessage(response.description);
            return;
          }

          this.handleErrorMessage(false);
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'bundle-product-form',
            productVariantId: firstVariantId
          });

          if (this.cart) {
            if (this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
            this.cart.renderContents(response);
          } else if (window.routes && window.routes.cart_url) {
            window.location = window.routes.cart_url;
          }
        })
        .catch(e => {
          console.error('[BundleProductForm] Cart add failed', e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          if (spinner) spinner.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage) {
      const wrapper = this.querySelector('.product-form__error-message-wrapper');
      if (!wrapper) return;

      wrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        const msg = wrapper.querySelector('.product-form__error-message');
        if (msg) msg.textContent = errorMessage;
      }
    }
  }

  customElements.define('bundle-product-form', BundleProductForm);
}
